import { render, staticRenderFns } from "./ImmobiliTable.vue?vue&type=template&id=ae8ba56e&"
import script from "./ImmobiliTable.vue?vue&type=script&lang=js&"
export * from "./ImmobiliTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ImmobiliTable.vue"
export default component.exports